import { makeStyles } from "@material-ui/core";
import ThemeSwitcher from "../../Optime/ThemeSwitcher/ThemeSwitcher";

const ThemeColor = ThemeSwitcher()

export const ConfStyle = makeStyles(() => ({
  wrapper: {
    // direction: props.dir,
    position: 'absolute',
    width: 'fit-content',
    height: 'fit-content',
    top: 16,
    left: 24,
  },
  bellWrapper: {
    zIndex: 2,
    position: "relative",
    cursor: 'pointer',
    animation: `$shake 4s linear forwards infinite`,
  },
  badge: {
    position: "absolute",
    zIndex: 3,
    top: -5,
    right: -8,
    borderRadius: 100,
    background: ThemeColor[9] + "bb",
    width: 20,
    fontSize: '.65rem',
    fontWeight: 700,
    height: 20,
    textAlign: 'center',
    lineHeight: 1.9,
    border: `1px solid ${ThemeColor[6]}`,
    cursor: 'pointer',
    color: ThemeColor[2],
  },
  "@keyframes shake": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "5%": {
      transform: "rotate(-25deg)",
    },
    "9%": {
      transform: "rotate(20deg)",
    },
    "12%": {
      transform: "rotate(-12deg)",
    },
    "14%": {
      transform: "rotate(8deg)",
    },
    "15%": {
      transform: "rotate(-5deg)",
    },
    "16%": {
      transform: "rotate(2deg)",
    },
    "17%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(0deg)",
    },
  },

  fadeRoot: {
    position: "absolute",
    backgroundColor: ThemeColor[1],
    left: 40,
    top: 0,
    padding: "2px 10px",
    zIndex: 1401,
    maxHeight: 180,
    overflow: 'auto',
    scrollbarColor: `${ThemeColor[6]} #C2D2E4`,
    scrollbarWidth: "thin",

    "&::-webkit-scrollbar": {
      width: 10,
    },

    "&::-webkit-scrollbar-track": {
      boxShadow: `inset 0 0 5px gray`,
      borderRadius: 10,
    },

    "&::-webkit-scrollbar-thumb": {
      background: ThemeColor[6],
      borderRadius: 10,
    },

    "&::-webkit-scrollbar-thumb:hover": {
      background: ThemeColor[5],
    },
  },
  itemIcon: {
    marginRight: 15
  },
  item: {
    minWidth: 170,
    maxWidth: 300,
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    margin: "4px 3px",
    padding: "5px",
    borderRadius: 5,
    zIndex: 5,
    "&:hover": {
      backgroundColor: ThemeColor[7],
      transition: "1s",
    },
  },
  message: {
    width: "100%",
    position: 'relative',
    top: 2
  },
  link: {
    textDecoration: 'none',
    color: ThemeColor[2]
  },
  driverInfoBox: {
    display: 'flex',
    flexDirection: 'column'
  }
}));